<template>
    <div class="fn-jump">
        <div class="jump-btn" @click="goPage">
            <img src="/static/img/course/btn_back.svg" alt="" />
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        goPage() {
            this.$router.go(-1);
        }
    }
};
</script>

<style lang="scss" scoped>
.fn-jump {
    position: fixed;
    right: 0px;
    bottom: 12vh;
}

.jump-btn {
    display: flex;
    flex-direction: column;
    align-items: center;

    img {
        width: 54px;
        height: 28px;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/medical-column/components/back.vue